module.exports = __webpack_public_path__ + "assets/f2d0caebd33a03401aabc45f32c4eeb2.svg";